// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    fuel: {
      label: 'Repostajes',
      help: 'Una fila por repostaje. Agrupa por vehículo antes de leer nada de kilómetros',
    },
    dates: {
      refuelled: 'Fecha del repostaje',
    },
    metrics: {
      cost: 'Gasto en combustible',
      litres: 'Litros',
      refuels: 'Repostajes',
      price: 'Precio por litro',
      distance: 'Kilómetros',
      consumption: 'Consumo por 100 km',
      costPerKm: 'Coste por kilómetro',
      firstKm: 'Cuentakilómetros más bajo',
      lastKm: 'Cuentakilómetros más alto',
    },
    dimensions: {
      vehicle: 'Vehículo',
      driver: 'Conductor',
      station: 'Gasolinera',
    },
    filters: {
      litres: 'Litros del repostaje',
      cost: 'Importe del repostaje',
    },
  },
  ca: {
    fuel: {
      label: 'Proveïments',
      help: 'Una fila per proveïment. Agrupa per vehicle abans de llegir res de quilòmetres',
    },
    dates: {
      refuelled: 'Data del proveïment',
    },
    metrics: {
      cost: 'Despesa en combustible',
      litres: 'Litres',
      refuels: 'Proveïments',
      price: 'Preu per litre',
      distance: 'Quilòmetres',
      consumption: 'Consum per 100 km',
      costPerKm: 'Cost per quilòmetre',
      firstKm: 'Comptaquilòmetres més baix',
      lastKm: 'Comptaquilòmetres més alt',
    },
    dimensions: {
      vehicle: 'Vehicle',
      driver: 'Conductor',
      station: 'Benzinera',
    },
    filters: {
      litres: 'Litres del proveïment',
      cost: 'Import del proveïment',
    },
  },
  en: {
    fuel: {
      label: 'Refuellings',
      help: 'One row per refuelling. Group by vehicle before reading anything about kilometres',
    },
    dates: {
      refuelled: 'Refuelled on',
    },
    metrics: {
      cost: 'Fuel cost',
      litres: 'Litres',
      refuels: 'Refuellings',
      price: 'Price per litre',
      distance: 'Distance',
      consumption: 'Consumption per 100 km',
      costPerKm: 'Cost per kilometre',
      firstKm: 'Lowest odometer',
      lastKm: 'Highest odometer',
    },
    dimensions: {
      vehicle: 'Vehicle',
      driver: 'Driver',
      station: 'Station',
    },
    filters: {
      litres: 'Litres in one fill',
      cost: 'Cost of one fill',
    },
  },
  fr: {
    fuel: {
      label: 'Pleins de carburant',
      help: 'Une ligne par plein. Regroupez par véhicule avant de lire quoi que ce soit sur les kilomètres',
    },
    dates: {
      refuelled: 'Date du plein',
    },
    metrics: {
      cost: 'Coût du carburant',
      litres: 'Litres',
      refuels: 'Pleins',
      price: 'Prix au litre',
      distance: 'Kilomètres',
      consumption: 'Consommation aux 100 km',
      costPerKm: 'Coût au kilomètre',
      firstKm: 'Compteur le plus bas',
      lastKm: 'Compteur le plus haut',
    },
    dimensions: {
      vehicle: 'Véhicule',
      driver: 'Conducteur',
      station: 'Station',
    },
    filters: {
      litres: 'Litres du plein',
      cost: 'Montant du plein',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
